import React from 'react'

const AllInsuranceContext = React.createContext()

export default AllInsuranceContext